import React, { useRef, useState } from "react";
import { format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { CustomButton, CustomDateCalendarPopUp, icon } from "../../../../common/components";
import { translate } from "../../../../common/providers";
import { DocumentService } from "../../../../api";
import { useApi } from "../../../../common/hooks";
import { updateDocumentsAttributes } from "../../slice/document-center-slice";

interface BulkDateChangeButton {
	selectedDocuments?: Array<number>;
}
const BulkDateChangeButton = ({ selectedDocuments }: BulkDateChangeButton) => {
	const { call: updateBulkEffectiveDates } = useApi(DocumentService.updateBulkEffectiveDates);
	const projectId = useSelector(({ context }) => context.project.id);
	const anchorRef = useRef<HTMLButtonElement>(null);
	const [open, setOpen] = useState(false);
	const [value, setValue] = useState<Date | null>(new Date());
	const dispatch = useDispatch();
	const handleEdit = (e: React.MouseEvent) => {
		e.stopPropagation();
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleChange = (newValue: Date | null) => {
		setValue(newValue);
	};
	const handleSubmit = () => {
		const attribute = {
			attributeKey: "Date d'effet du texte",
			attributeValue: format(value || "", "yyyy-MM-dd HH:mm:ss")?.substring(0, 10),
			attributeType: "DATE",
		};
		updateBulkEffectiveDates(
			{ projectId },
			{
				ids: selectedDocuments,
				attribute,
			}
		)
			.then(() => {
				dispatch(
					// eslint-disable-next-line max-len
					// eslint-disable-next-line @typescript-eslint/no-explicit-any -- arg type isn't inferable from the JS thunk
					(updateDocumentsAttributes as any)({
						ids: selectedDocuments,
						attribute,
					})
				);
			})
			.catch(console.error);
		handleClose();
	};
	return (
		<>
			<CustomButton
				ref={anchorRef}
				size="sm"
				startIcon={icon.faCalendarAlt}
				variant="outlined"
				onClick={handleEdit}
			>
				{translate("document-center.table.actions.edit-issuance-date")}
			</CustomButton>
			<CustomDateCalendarPopUp
				ref={anchorRef}
				open={open}
				submitButtonText={translate(
					selectedDocuments?.length === 1
						? "document-center.table.actions.edit-issuance-date.submit.singular"
						: "document-center.table.actions.edit-issuance-date.submit.plural",
					{ count: selectedDocuments?.length }
				)}
				value={value}
				onChange={handleChange}
				onClose={handleClose}
				onSubmit={handleSubmit}
			/>
		</>
	);
};

export default BulkDateChangeButton;
